import Duck from "redux-ducks-ts"

export const preference = new Duck("preference", "cargo")
